import { createContext, useContext, useState } from "react";
import { Dialog, DialogContent, DialogTitle } from "./ui/dialog";
import BookingEmbed from "./BookingEmbed";
import { track } from "../lib/api";

const Ctx = createContext({ openRequest: () => {} });

export const useRequestModal = () => useContext(Ctx);

export function RequestModalProvider({ children }) {
  const [open, setOpen] = useState(false);

  const openRequest = (size = null) => {
    track("request_dumpster_click", { size: size || "none" });
    setOpen(true);
  };

  return (
    <Ctx.Provider value={{ openRequest }}>
      {children}
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="sm:max-w-[720px] max-h-[92vh] overflow-y-auto p-0 gap-0" data-testid="request-modal">
          <DialogTitle className="sr-only">Request a Dumpster</DialogTitle>
          <BookingEmbed />
        </DialogContent>
      </Dialog>
    </Ctx.Provider>
  );
}
